import Vue from "vue";
import Vuex from "vuex";
import home from "./home";
import banner from "./banner";
import apps from "./apps";
import messageDialog from "./messageDialog";
import snackbar from "./snackbar";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    home,
    banner,
    apps,
    messageDialog,
    snackbar,
  },
});
